import { Queue } from '~/apps/smartsend/lib/helpers/ApiCache';
import { SettingsCache } from '~/lib/consts/settings-cache';

const maxQueue = Infinity;
export const DefaultSmartSendQueue = new Queue(SettingsCache.settings.Limits.MaxStandardQueueConcurrency, maxQueue);
export const SmartSendQuoteQueue = new Queue(SettingsCache.settings.Limits.MaxQuoteQueueConcurrency, maxQueue);
export const SmartSendBookQueue = new Queue(SettingsCache.settings.Limits.MaxBookQueueConcurrency, maxQueue);
export const SmartSendStatsQueue = new Queue(1, maxQueue);
export const SmartSendTrackingQueue = new Queue(3, maxQueue);
